import { memo } from "react";
import TextInputPermitPDF from "../../inputs/TextInputPermitPDF";
import { formattedDateTimeWithoutSec } from "../../../lib/functions";

interface PermitValidityProps {
    permitDetails: {
        dt_PermitStartDate: string;
        dt_PermitEndDate: string;
    };
}

const PermitValidity = ({
    permitDetails,
}: PermitValidityProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-b border-black py-0.5">
                <span className="text-[10px] font-bold text-white">
                    Section 6: Permit Validity
                </span>
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Permit Start Date:"
                    value={permitDetails?.dt_PermitStartDate ? formattedDateTimeWithoutSec(permitDetails?.dt_PermitStartDate) : ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Permit End Date:"
                    value={permitDetails?.dt_PermitEndDate ? formattedDateTimeWithoutSec(permitDetails?.dt_PermitEndDate) : ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>
        </div>
    );
};

export default memo(PermitValidity);
